export default "__VITE_ASSET__wpRU4ai8__"